import {useMutation} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setSilent} from "../../../../redux/meta.js";
import {MAIN_REJESTR_API_SHORT} from "../../../../components/utils/consts.js";
import {create} from "../../../app/setters/create.js";

export const useInicjujProjekt = (setErrors) => {
    const role = useSelector(state => state.user.role);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    return useMutation({
        mutationFn: (data) => create(`/${MAIN_REJESTR_API_SHORT}`, data),
        onError: (err) => {
            setErrors(err.response.data.errors);
            toast.error('Błąd podczas operacji')
        },

        onSuccess: ({message, status}) => {
            dispatch(setSilent(true))
            navigate(`/${role}/rejestr/lista`)
            status === 'success' ? toast.success(message) : toast.error(message)
        },
    })
}